import { render, staticRenderFns } from "./selected-filters.vue?vue&type=template&id=bd82c6b4&"
import script from "./selected-filters.vue?vue&type=script&lang=ts&"
export * from "./selected-filters.vue?vue&type=script&lang=ts&"
import style0 from "./selected-filters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports